import { TextField } from '@mui/material';
import { useEffect } from 'react';
import { NumericTextField } from '../../components/NumericTextField';
import { useContext } from './context.jsx';
import { CheckboxButton } from '../../components/CheckboxButton.jsx';

export function NumericInput(props) {
  return <Input ignoreNonNumericInput numeric {...props} />;
}

export function Radio({ name, value, sx, ...passThroughProps }) {
  const { getParam, updateParam, getError } = useContext();

  return (
    <CheckboxButton
      sx={{
        width: '100%',
        height: 34,
        p: 0.5,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        '& .MuiTypography-root': { fontSize: 13 },
        ...sx,
      }}
      color="inherit"
      checked={getParam(name) === value}
      onChange={() => updateParam(name, value)}
      error={Boolean(getError(name))}
      helperText={getError(name)}
      {...passThroughProps}
    />
  );
}

export function Checkbox(props) {
  const { getParam, updateParam } = useContext();

  return (
    <Radio
      radio={false}
      onChange={(e) => updateParam(props.name, e.target.checked)}
      checked={Boolean(getParam(props.name))}
      {...props}
    />
  );
}

export function Select({ options, children, ...props }) {
  return (
    <Input select {...props}>
      {options || children}
    </Input>
  );
}

function Input({ numeric, name, defaultValue, ...passThrough }) {
  const { getError, getParam, updateParam } = useContext();
  const Component = numeric ? NumericTextField : TextField;

  useEffect(() => {
    if (defaultValue && !getParam(name)) {
      updateParam(name, defaultValue);
    }
  }, [defaultValue, getParam, name, updateParam]);

  return (
    <Component
      size="small"
      InputLabelProps={{ shrink: true }}
      inputProps={{ autoComplete: 'off' }}
      fullWidth
      name={name}
      value={getParam(name)}
      error={Boolean(getError(name))}
      helperText={getError(name)}
      onChange={(e) => updateParam(e.target.name, e.target.value)}
      {...passThrough}
    />
  );
}
